import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import ProjectCard from '../molecules/ProjectCard';
import CardCarousel from '../organisms/ProjectCarousel';
import courseraImg from '../../assets/coursera.png';
import tegakiImg from '../../assets/tegaki.png';
// import wordwakuImg from '../../assets/wordwaku.png';
import braintumor from '../../assets/brain-tumor-mri.png';
import restaurantFinder from '../../assets/rf.png';
import histopathological from '../../assets/histopathological-cancer-dl.png';
import unityImg from '../../assets/unity.png';
import unsupervisedImg from '../../assets/spot.png';
import ganImg from '../../assets/gan.png';
import kklcwrImg from '../../assets/kklcwr.png';
import Tags from '../molecules/Tags';

const HeaderContainer = styled.header`
  background: rgb(5, 5, 7);
  min-height: 600px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 2rem 2rem 1rem;
  color: white;

  /* Increase bottom padding on mobile */
  @media (max-width: 600px) {
    padding-bottom: 3rem;
  }
`;

const ContentContainer = styled.div`
  max-width: 1000px;
  width: 100%;
`;

const MainTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 3rem;
  text-align: center;
`;

const projects = [
  {
    image: braintumor,
    title: 'MRI Brain Tumor Classification',
    description:
      'A supervised machine learning classification project for detecting brain tumors by MRI scans.',
    link: 'https://github.com/JamesScottCode/brain-tumor-detection/blob/main/models.ipynb',
    tags: ['AI'],
  },

  {
    image: restaurantFinder,
    title: 'Tokyo Restaurant Finder',
    description: 'A site for finding restaurants in Tokyo - built with react',
    link: 'https://github.com/JamesScottCode/restaurant-finder',
    tags: ['REACT'],
  },
  // {
  //   image: wordwakuImg,
  //   title: 'Word Waku',
  //   description:
  //     'A site for Japanese language learners. Built with React, Express, Node.js, MongoDB, AntDesign.',
  //   link: 'http://wordwaku.com',
  //   tags: ['REACT', 'FULLSTACK'],
  // },
  {
    image: courseraImg,
    title: 'Coursera Sharable Link',
    description:
      'Chrome extension to create a shareable link to peer-review projects on Coursera. 300+ Users',
    link: 'https://chromewebstore.google.com/detail/coursera-shareable-link/llognpblofcojjfmkeogoacchhmfacoe',
    tags: ['CHROME EXTENSION'],
  },

  {
    image: tegakiImg,
    title: 'Tegaki - Kanji Writing',
    description:
      `Released in 2026, it's the only Kanji writing focused app on IOS App Store. Made with React Native. Has active and paying users.`,
    link: 'https://apps.apple.com/us/app/tegaki-kanji-writing/id6761772613',
    tags: ['REACT', 'MOBILE'],
  },
  {
    image: kklcwrImg,
    title: 'KKLC/WR Kanji# Lookup',
    description:
      'Hover over a kanji to find the KKLC # or White Rabbit flashcard # for easy reference to the physical book# or flashcard#.',
    link: 'https://chromewebstore.google.com/detail/kklc-white-rabbit-kanji-l/lnmedgmkddblkhphalcjejelcgjkpcco?authuser=0&hl=en',
    tags: ['CHROME EXTENSION'],
  },
  {
    image: histopathological,
    title: 'Histopathological Cancer Detection',
    description:
      'Kaggle Competition: Deep learning techniques to identify metastatic tissue in histopathologic scans of lymph node sections.',
    link: 'https://github.com/JamesScottCode/histopathologic-cancer-detection/blob/main/histopathologic-cancer-detection.ipynb',
    tags: ['AI', 'KAGGLE'],
  },
  {
    image: unityImg,
    title: 'Unity Game - Infinite Runner',
    description:
      'Unity Game: Infinite runner game with a Japanese theme. I made this just to learn the basics of Unity.',
    link: 'https://github.com/JamesScottCode/samuraiRunner',
    tags: ['GAME DEVELOPMENT'],
  },

  {
    image: unsupervisedImg,
    title: 'Unsupervised ML - Spotify Tracks',
    description:
      'An unsupervised machine learning project to explore and uncover spotify tracks relationships. Precursor for extending into a recommender system.',
    link: 'https://github.com/JamesScottCode/unsupervised-learning/blob/main/unsupervised_models.ipynb',
    tags: ['AI'],
  },
  {
    image: ganImg,
    title: 'GAN - Monet Image',
    description:
      'Kaggle Competition: Generate Monet style images based on a reference image using deep learning techniques.',
    link: 'https://github.com/JamesScottCode/gan-monet/blob/main/ML3_W5.ipynb',
    tags: ['AI', 'KAGGLE'],
  },
];

const Projects: FC = () => {
  const [selectedTag, setSelectedTag] = useState('');
  const [displayedProjects, setDisplayedProjects] = useState(projects);

  useEffect(() => {
    if (selectedTag === '') {
      setDisplayedProjects(projects);
    } else {
      const filteredProjects = projects.filter((project: any) => {
        return project.tags.includes(selectedTag);
      });
      setDisplayedProjects(filteredProjects);
    }
  }, [selectedTag]);

  return (
    <HeaderContainer id="projects">
      <ContentContainer>
        <MainTitle>Projects</MainTitle>
        <Tags selectTag={setSelectedTag} selectedTag={selectedTag} />
        <CardCarousel
          key={selectedTag}
          cards={displayedProjects.map((project: any) => {
            const { image, title, description, link, tags } = project;
            return (
              <ProjectCard
                image={image}
                title={title}
                description={description}
                link={link}
                tags={tags}
              />
            );
          })}
        />
      </ContentContainer>
    </HeaderContainer>
  );
};

export default Projects;
